import React from 'react';
import ProfileForm from './ProfileForm';

const Setting = () => {
	return <ProfileForm />;
};

export default Setting;
